import Swiper from 'swiper';

export default class cardBrowser {
  constructor(el) {
    this.el = el;
    this.carousel = null;
    this.buttons = [...el.getElementsByTagName('a')];
    this.init();
  }

  tabIndexHandler(swiper) {
    const activeButtons = this.buttons.slice(swiper.activeIndex, swiper.activeIndex + swiper.params.slidesPerGroup);
    this.buttons.forEach((button) => button.setAttribute('tabindex', -1));
    activeButtons.forEach((button) => button.setAttribute('tabindex', 0));
  }

  init() {
    this.carousel = new Swiper(this.el, {
      a11y: true,
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 20,
      nextButton: '.c-card-browser__button--next',
      prevButton: '.c-card-browser__button--prev',
      breakpoints: {
        // when window width is <= 767px
        767: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
        // when window width is <= 1199px
        1199: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
      },      
      pagination: '.c-card-browser__pagination',
      paginationClickable: true,      
      wrapperClass: 'c-card-browser__wrapper',
      slideClass: 'c-card-browser__slide',
      bulletClass: 'c-card-browser__bullet',
      bulletActiveClass: 'c-card-browser__bullet--active',
      notificationClass: 'sr-only',
      onInit: (swiper) => this.tabIndexHandler(swiper),
      onAfterResize: (swiper) => this.tabIndexHandler(swiper),
      onSlideChangeStart: (swiper) => this.tabIndexHandler(swiper),
    });
  }
}
